<div class="flex flex-col gap-4 md:gap-6 rounded-md bg-shui-base-3 p-4 md:p-6 max-w-[900px]">
    <div class="flex flex-col gap-1 mb-2 md:mb-4">
        <h2 class="text-base md:text-lg font-semibold text-shui-text-strong p-0 m-0">
            {{ 'common.settings.notifications.title' | translate }}
        </h2>
        <p class="text-xs md:text-sm text-shui-text-subtle p-0 m-0">
            {{ 'common.settings.notifications.subtitle' | translate }}
        </p>
    </div>

    <div class="flex flex-col gap-6" [formGroup]="notificationForm()">
        <!-- Statusänderungen -->
        <div class="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-4">
            <div class="flex flex-col gap-1">
                <span class="text-sm font-medium text-shui-text-strong">{{
                    'common.settings.notifications.state-transitions.title' | translate
                }}</span>
                <span class="text-xs text-shui-text-subtle">{{
                    'common.settings.notifications.state-transitions.description' | translate
                }}</span>
            </div>
            <sh-toggle-accessor
                data-testid="toggle-state-transition-notifications"
                formControlName="stateTransitionNotificationsEnabled"
            ></sh-toggle-accessor>
        </div>

        <!-- Kommentare -->
        <div class="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-4">
            <div class="flex flex-col gap-1">
                <span class="text-sm font-medium text-shui-text-strong">{{
                    'common.request-detail.tabs.comments' | translate
                }}</span>
                <span class="text-xs text-shui-text-subtle">{{
                    'common.settings.notifications.comments.description' | translate
                }}</span>
            </div>
            <sh-toggle-accessor
                data-testid="toggle-comment-notifications"
                formControlName="commentNotificationsEnabled"
            ></sh-toggle-accessor>
        </div>

        <!-- Erinnerungen -->
        <div class="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-4">
            <div class="flex flex-col gap-1">
                <span class="text-sm font-medium text-shui-text-strong">{{
                    'common.settings.notifications.reminders.title' | translate
                }}</span>
                <span class="text-xs text-shui-text-subtle">{{
                    'common.settings.notifications.reminders.description' | translate
                }}</span>
            </div>
            <sh-toggle-accessor
                data-testid="toggle-reminder-notifications"
                formControlName="reminderNotificationsEnabled"
            ></sh-toggle-accessor>
        </div>
    </div>
</div>
